import React from "react";
import { motion } from "framer-motion";
import "./techMarquee.css";

const TechMarquee = () => {
  const technologies = [
    { name: "React.js", icon: "./icon/reactjs.png" },
    { name: "Node.js", icon: "./icon/nodejs.png" },
    { name: "JavaScript", icon: "./icon/javascript.png" },
    { name: "TypeScript", icon: "./icon/ts.svg" },
    { name: "Python", icon: "./icon/python.png" },
    { name: "Django", icon: "./icon/django.png" },
    { name: "Next.js", icon: "./icon/nextjs.png" },
    { name: "MySQL", icon: "./icon/mysql.png" },
    { name: "MongoDB", icon: "./icon/mongodb.png" },
    { name: "AWS", icon: "./icon/aws.png" },
    { name: "Git", icon: "./icon/git.png" },
    { name: "Linux", icon: "./icon/linux.png" },
    { name: "Figma", icon: "./icon/figma.png" },
    { name: "HTML5", icon: "./icon/html.png" },
    { name: "CSS3", icon: "./icon/css.png" },
  ];

  // Duplicate the array for seamless looping
  const duplicatedTechnologies = [...technologies, ...technologies];

  return (
    <div className="tech-marquee-wrapper">
      <div className="tech-marquee-container">
        <div className="tech-marquee-header">
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h3 className="tech-marquee-title">
              <i className="fa fa-code" style={{ marginRight: "10px", color: "var(--accent-color)" }} />
              TRUSTED TECHNOLOGIES
            </h3>
            <p className="tech-marquee-subtitle">
              Powered by industry-leading tools and frameworks
            </p>
          </motion.div>
        </div>

        <div className="tech-marquee-track-container">
          <motion.div
            className="tech-marquee-track"
            animate={{
              x: ["0%", "-50%"],
            }}
            transition={{
              x: {
                repeat: Infinity,
                repeatType: "loop",
                duration: 25,
                ease: "linear",
              },
            }}
          >
            {duplicatedTechnologies.map((tech, index) => (
              <div key={index} className="tech-marquee-item">
                <div className="tech-icon-wrapper">
                  <img src={tech.icon} alt={tech.name} className="tech-icon" />
                </div>
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </motion.div>
        </div>

        <div className="tech-marquee-gradient-left"></div>
        <div className="tech-marquee-gradient-right"></div>
      </div>
    </div>
  );
};

export default TechMarquee;
